"use client";

import { Link } from "@homeinstead/ui/components/Link";
import { useLocale } from "~www/components/LocaleProvider";

// Copy is the legacy privacy disclaimer until Legal reviews it.
function PrivacyDisclaimer() {
  const locale = useLocale();

  return (
    <p className="text-center text-xs leading-relaxed">
      By clicking &quot;Contact me with care options&quot; you agree to our{" "}
      <Link
        className="text-xs"
        href={`${locale.metadata.canonicalOrigin}/legal/client-notice-of-privacy-practices`}
        rel="noopener noreferrer"
        size="inline"
        target="_blank"
        variant="plain"
      >
        Privacy Policy
      </Link>
      .
    </p>
  );
}

export { PrivacyDisclaimer };
